export default "__VITE_ASSET__BRv8k4ru__"